// Localização
(function () {
  "use strict";

  function initMap() {
    const element = $("#anuncio-det-mapa");
    const icon = element.data("icon");
    const lat = element.data("lat");
    const lng = element.data("lng");

    const mapOptions = {
      zoom: 15,
      center: new google.maps.LatLng(lat, lng),
    };

    const mapElement = element.get(0);
    const map = new google.maps.Map(mapElement, mapOptions);

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(lat, lng),
      icon: icon,
      map: map,
    });
  }

  $(window).load(function () {
    if ($("#anuncio-det-mapa").length > 0) {
      initMap();
    }
  });
})();

// Carrosel de anúncios relacionados
(function () {
  "use strict";

  $(".carrosel-anuncios").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
})();

// Calendário
(function () {
  "use strict";

  if ($("#form-lateral").length > 0) {
    // Data indisponíveis
    const datasIndisponiveis = $("#datas-indisponiveis").val().split(",");
    // Data diferenciadas
    const datasDiferenciadas = $("#datas-diferenciadas").val().split(",");
    // Mínimo de noites
    const minNoites = $("#min-noites").val()
      ? parseInt($("#min-noites").val())
      : 9999;

    // Datepicker Range
    $(".datepicker_range_reserva").each(function () {
      const $campoChegada = $(this);
      const openDirection =
        $campoChegada.data("direction") &&
        $campoChegada.data("direction") === "right"
          ? "left"
          : "right";
      const $campoSaida = $($campoChegada.data("input-range"));
      $campoSaida.on("focus", function () {
        $campoChegada.focus();
      });
      $campoChegada
        .daterangepicker({
          autoUpdateInput: false,
          autoApply: true,
          showCustomRangeLabel: true,
          opens: openDirection,
          locale: datepickerLocaleBR,
          buttonClasses: "btn btn-xs",
          applyButtonClasses: "btn-primario",
          isInvalidDate: function (date) {
            if (datasIndisponiveis.indexOf(date.format("DD/MM/YYYY")) !== -1) {
              return true;
            }
          },
          isCustomDate: function (date) {
            if (datasDiferenciadas.indexOf(date.format("DD/MM/YYYY")) !== -1) {
              return "data-diferenciada";
            }
          },
        })
        .on("show.daterangepicker", function (ev, picker) {
          $campoSaida.addClass("active");
        })
        .on("apply.daterangepicker", function (ev, picker) {
          // Variáveis
          const chegada = picker.startDate.format("DD/MM/YYYY");
          const saida = picker.endDate.format("DD/MM/YYYY");
          const datasRange = getDateRange(dataToObj(chegada), dataToObj(saida));
          const totalNoites = datasRange.length - 1;

          // Verifica se as datas estão disponíveis
          if (!rangeInvalido(datasIndisponiveis, datasRange)) {
            // Verifica se a quantidade de dias é menor do que o mínimo permitido
            if (totalNoites >= minNoites) {
              $campoSaida.removeClass("active");
              $campoChegada.val(chegada);
              $campoSaida.val(saida);
              $campoChegada.parsley().validate();
              $campoSaida.parsley().validate();
            } else {
              clearDatas();
              showAlert(
                "Atenção",
                "Por favor, escolha no mínimo <b>" +
                  (minNoites + 1) +
                  " dias</b>.",
                "warning"
              );
            }
          } else {
            clearDatas();
            showAlert(
              "Atenção",
              "Existem <b>datas indisponíveis</b> entre a data de <b>chegada</b> e <b>saída</b> que você selecionou. Por favor, escolha outras datas.",
              "warning"
            );
          }

          // Reseta os campos de data
          function clearDatas() {
            $campoSaida.removeClass("active");
            $campoChegada.val("");
            $campoSaida.val("");
            const hoje = new Date();
            picker.setStartDate(hoje);
            picker.setEndDate(hoje);
          }
        })
        .on("hide.daterangepicker", function (ev, picker) {
          $campoSaida.removeClass("active");
        })
        .on("cancel.daterangepicker", function (ev, picker) {
          $campoSaida.removeClass("active");
          $campoChegada.val("");
          $campoSaida.val("");
        });
    });
  }
})();

// Campo star
$(".star-rating-input i").on("click", function () {
  $(".star-rating-input i").removeClass("checked active");
  $(this).addClass("checked active");
  $("#avaliacao-input").val($(this).data("value"));
  for (var i = 1; i <= $(this).data("value"); i++) {
    $('.star-rating-input i[data-value="' + i + '"]').addClass("active");
  }
  // Valida o formulário
  $("#avaliacao-input").parsley().validate();
});

// Envia avaliação
var enviando_formulario = false;
$("#form-avaliacao").on("submit", function (e) {
  e.preventDefault();

  var obj = this;
  var form = $(obj);
  var submit_btn = form.find("#enviar_avaliacao");
  var submit_btn_text = submit_btn.text();
  var dados = new FormData(obj);

  function volta_submit() {
    submit_btn.attr("disabled", false);
    submit_btn.text(submit_btn_text);
    enviando_formulario = false;
    hideLoading();
  }

  if (!enviando_formulario) {
    $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      beforeSend: function () {
        showLoading();
        enviando_formulario = true;
        submit_btn.attr("disabled", true);
        submit_btn.text("Enviando...");
      },
      success: function (data) {
        //console.log(data);
        volta_submit();
        if (data == "ok") {
          closeModal("modal-avaliacao");
          $("#form-avaliacao .campo").val("");
          showAlert(
            "Sucesso",
            "Obrigado! Sua avaliação foi enviada com sucesso.",
            "success"
          );
        } else {
          showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
        }
      },
      error: function (xhr, type, exception) {
        volta_submit();
        showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
        console.log("ajax error response type " + type);
      },
    });
  }
});
